import { Typography } from '@mui/material';
import { ChatChannelType } from 'src/@types/chat';
import Iconify from 'src/components/iconify';
import {
  NavAccordionDetails,
  NavAccordionSummary,
} from 'src/features/Navbar/NavAccordion';
import { NavAccordionLabel } from 'src/features/Navbar/NavAccordion/NavAccordion';
import { NavAccordionPersisted } from 'src/features/Navbar/NavAccordionPersisted';
import { NavActionButton } from 'src/features/Navbar/NavActionButton/NavActionButton';
import { useLocales } from 'src/locales';
import { ChatNav } from 'src/sections/@dashboard/chat';
import { useCreateChatChannelModal } from 'src/sections/@dashboard/chat/shared/CreateChatChannelModal';
import { ChatCreateTitle } from 'src/sections/@dashboard/chat/shared/CreateChatChannelModal/constants';
import { UIFeature } from 'src/state/ui/types';

export const NavTextChannel = () => {
  const { showChatDetailsDialog } = useCreateChatChannelModal();
  const { translate } = useLocales();

  return (
    <NavAccordionPersisted feature={UIFeature.channels}>
      <NavAccordionSummary className="chat">
        <NavAccordionLabel>
          <Iconify className="navIcon" icon="copera:nav-chat" />
          <Typography variant="subtitle2" whiteSpace="nowrap">
            {translate('header.nav_vertical.communicate.chat_channels')}
          </Typography>
        </NavAccordionLabel>
        <NavActionButton
          icon="tabler:plus"
          onClick={(e) => {
            e.stopPropagation();
            showChatDetailsDialog({ tab: ChatCreateTitle.TEXT });
          }}
        />
      </NavAccordionSummary>
      <NavAccordionDetails>
        <ChatNav type={ChatChannelType.TEXT} />
      </NavAccordionDetails>
    </NavAccordionPersisted>
  );
};
